<template>
  <v-dialog :model-value="modelValue" max-width="620" @update:model-value="$emit('update:modelValue', $event)">
    <v-card>
      <v-card-title>{{ form.id ? 'Клиент' : 'Новый клиент' }}</v-card-title>
      <v-card-text class="form-grid">
        <v-text-field v-model="form.name" label="Имя" />
        <v-text-field v-model="form.phone" label="Телефон" />
        <v-textarea v-model="form.notes" label="Заметки" rows="4" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="text" @click="$emit('update:modelValue', false)">Отмена</v-btn>
        <v-btn color="primary" prepend-icon="mdi-content-save-outline" @click="$emit('save', form)">Сохранить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { reactive, watch } from 'vue';
const props = defineProps({ modelValue: Boolean, client: Object });
defineEmits(['update:modelValue', 'save']);
const form = reactive({ id: null, name: '', phone: '', notes: '', details: {} });
watch(() => props.client, (value) => Object.assign(form, { id: null, name: '', phone: '', notes: '', details: {}, ...(value || {}) }), { immediate: true });
</script>
